/* custom helpers */
import { filterFoo, find, where } from './Helpers.js';

export class Mold {

    /**
     * This constructor takes a data
     * argument that is used to manipulate
     * using the different methods available
     * within this class.
     */

    constructor(data) {
        this.data = data;
    }

    /** ----------------------------------------
        Check Array
     ---------------------------------------- */

    /**
     * Check to see if a value is an array.
     *
     * @value           item
     * @return          boolean is array
     */

    _isArray(value) {
        return value.constructor === Array;
    }

    /** ----------------------------------------
        Select Key
     ---------------------------------------- */

    /**
     * Select a key from a given object, use
     * the take method to return the results.
     *
     * @name        name of selection
     * @return      results based on selection
     */

    select(name) {
        if(typeof this.data === 'object')
            this.data = [this.data];

        this.data = this.data.reduce((array, item) => {
            if(item[name])
                return array.concat(item[name]);
        }, '');

        return new Mold(this.data);
    }

    /** ----------------------------------------
        Index
     ---------------------------------------- */

    /**
     * This method will return a given index
     * number of an array with results.
     *
     * @number          number of index
     * @return          specific item
     */

    index(number) {
        this.data = this.data[number];
        return new Mold(this.data);
    }

    /** ----------------------------------------
        Length
     ---------------------------------------- */

    /**
     * This method will return the length of
     * the collected results.
     *
     * @result          returns the length of data
     */

    length() {
        return this.data.length;
    }

    /** ----------------------------------------
        Take Results
     ---------------------------------------- */

    /**
     * Take a given amount of results, by
     * default it will return all the results.
     *
     * @amount          number of items
     * @result          amount of items given
     */

    take(amount = this.length()) {
        return this.data.slice(0, amount);
    }

    /** ----------------------------------------
        Sort By
     ---------------------------------------- */

    /**
     * Take a given amount of results, by
     * default it will return all the results.
     *
     * @amount          number of items
     * @result          amount of items given
     */

    sortBy(value) {
        this.data = this.data.sort((a, b) => {
            return new Date(a[value]) - new Date(b[value])
        });

        return new Mold(this.data);
    }

    /** ----------------------------------------
        Random Results
     ---------------------------------------- */

    /**
     * This random method can be used during
     * development to quickly return chucks
     * of data randomly. Results can be used
     * to quickly mockup templates.
     *
     * @amount          number of items
     * @result          amount of items given
     */

    random(amount) {
        let numbers = [];

        if(amount > this.data.length)
            return new Error(`To many results requested, only ${ this.data.length } available!`);

        while(numbers.length < amount) {
            let random = Math.floor(Math.random() * this.data.length - 1) + 1;
            if (numbers.indexOf(random) === -1)
                numbers.push(random);
        }

        this.data = numbers.map(index => this.data[index]);
        return new Mold(this.data);
    }

    /** ----------------------------------------
        Take First
     ---------------------------------------- */

    /**
     * Take the first result given from an
     * array and return the result.
     *
     * @result          first item of results
     */

    first() {
        if(!this.data)
            return new Error('There is not enough data available to request');

        return this.data[0];
    }

    /** ----------------------------------------
        Take Last
     ---------------------------------------- */

    /**
     * Take the last result given from an
     * array and return the result.
     *
     * @result          last item of results
     */

    last() {
        if(!this.data)
            return new Error('There is not enough data available to request');

        return this.data[this.data.length - 1];
    }

    /** ----------------------------------------
        Take Offset
     ---------------------------------------- */

    /**
     * Take the last result given from an
     * array and return the result.
     *
     * @amount          amount of offset
     * @result          previous set except offset
     */

    offset(amount) {
        if(amount > this.data.length)
            return new Error('There is not enough data available to request this amount of offset');

        return this.data.splice(amount);
    }

    /** ----------------------------------------
        Where Match
     ---------------------------------------- */

    /**
     * Check where a value is either higher or
     * lower then a given value
     *
     * @key             the key of object
     * @operator        lower or higher
     * @value           the related values
     */

    where(key, operator, value) {
        this.data = where(this.data, key, operator, value);
        return new Mold(this.data);
    }

    /** ----------------------------------------
        Find Match
     ---------------------------------------- */

    /**
     * Takes a given value and match for a
     * key value pair in an object.
     *
     * @key             the key of object
     * @value           the related values
     */

    find(key, value) {
        this.data = find(this.data, key, value);
        return new Mold(this.data);
    }

    /** ----------------------------------------
        Filter
     ---------------------------------------- */

    /**
     * This method will filter a object for
     * a specific hit on a key recursively.
     *
     * @key             the key of object
     * @value           the related values
     */

    filter(key, value) {
        let matches = [];

        this.data.map((obj, i) => {

            if (filterFoo(obj, key, value)) {
                matches.push(obj);
            }
            return;
        });

        this.data = matches;
        return new Mold(this.data);
    }

    /** ----------------------------------------
        Pick
     ---------------------------------------- */

    /**
     * Used to retrieve a specific key from an
     * array of objects, will return a new
     * array of data with the values of the
     * given key.
     *
     * @key         key of object
     * @return      array of values
     */

    pick(key) {
        let array = [];
        this.data.map(item => array.push(item[key]));
        return new Mold(array);
    }

    /** ----------------------------------------
        Log Result
     ---------------------------------------- */

    /**
     * The log method can be used for debugging
     * purposes during development to instantly
     * return a result back to the console.
     *
     * @return      returns items to console
     */

    log() {
        console.log(this.data);
    }

}